(function($, root) {

  $.hideMain = function(show) {
    show = show || false;
    $('main .main, #full-page-background').removeClass('fadeIn').animateCss('fadeOut', function() {

      $('body').removeClass('show-content');
      if (show=="index") {
        $('body').addClass('show-index');

        setTimeout(function() {
          window.rdo.index.shown = true;
          window.rdo.verticaltimeline.wait = 1000;
          window.rdo.header.shown = false;
          $('index').fadeIn();

        }, 500);

      }
      if (show=="modal") {
        $('body').addClass('show-modal');

        setTimeout(function() {
          window.rdo.modal.shown = true;
          window.rdo.verticaltimeline.wait = 1000;
          window.rdo.header.shown = false;
          $('modal').fadeIn();

        }, 500);
      }


      $.hideTimelines();
      $.hideSpinner();

      $('main').fadeOut();

    });
  }
})(jQuery, this);
